window.isYoutubeAPILoaded = false;
function loadYoutubeAPI() {
  if (window.isYoutubeAPILoaded) {
  } else {
    // Load Youtube API script
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}
function onYouTubeIframeAPIReady() {
  window.isYoutubeAPILoaded = true;
  document.body.dispatchEvent(new CustomEvent('youtubeAPIReady'));
}
window.isPlyrLoaded = false;
function loadPlyr() {
  if (window.isPlyrLoaded) {
  } else {
    // Load Youtube API script
    try {
      window.Shopify.loadFeatures(
        [
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: handleShopifyXRLoadError,
          },
        ],
        plyrLoaded
      );
    } catch (error) {
      console.log('An error occured while loading the Shopify Video interface');
      throw error;
    }
  }
}
function plyrLoaded() {
  window.isPlyrLoaded = true;
  document.body.dispatchEvent(new CustomEvent('plyrReady'));
}
function handleShopifyXRLoadError(error) {
  if (error) {
    throw error;
  }
}
window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
window.loadYoutubeAPI = loadYoutubeAPI;
window.loadPlyr = loadPlyr;
